import React from 'react';
import Footer from './Footer';

const Products = ({ allItems }) => {
    document.title = 'SIHAH - Products';

    return (
        <>
        <section id="products" className="py-5 text-center container">
            <h1 className="mb-5 title"><b>All Products : {allItems.length}</b></h1>
            <div className="card-columns">
                {
                    allItems.map(item => <div className="card border-0 shadow" key={item.id}>
                        <img src={item.data.photo} alt={item.data.name} className="img-fluid card-image-top" />
                        <div className="card-body text-center">
                            <h5><b>{item.data.name}</b></h5>
                            <h6 className="text-secondary">Price: {item.data.price}/=</h6>
                        </div>
                    </div>)
                }
            </div>
        </section>
        <Footer />
        </>
    );
};

export default Products;